import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './BookmarkToggle.styles'

import { useTextContext } from 'hocs'

/**
 * bookmark toggle button
 */
const BookmarkToggle = ({ selected, onToggle, className, disabled }) => {
  const textContext = useTextContext()

  return (
    <Styled.BookmarkToggleComponent
      isBookmarked={ selected }
      className={ className }
      data-cy='bookmark-toggle'>
      <Styled.BookmarkToggleButton
        isBookmarked={ selected }
        disabled={ disabled }
        onClick={ () => !disabled && onToggle() }>
        <span className='bookmark-text'>
          {selected
            ? textContext['bookmark.isSetAction']
            : textContext['bookmark.isUnsetAction']}
        </span>
      </Styled.BookmarkToggleButton>
    </Styled.BookmarkToggleComponent>
  )
}

BookmarkToggle.defaultProps = {
  disabled: false,
  selected: false,
  onToggle: () => {},
  className: '',
}

BookmarkToggle.propTypes = {
  selected: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default BookmarkToggle
